import React from 'react';
import { Box } from '@material-ui/core';
import edit from 'src/assets/images/Edit.svg';
import ItemTemplateDesktop from 'src/pages/reportUsage/record/components/itemsList/ItemListContainerDesktop/itemTemplateDesktop';
import { Checkbox } from 'src/common/components/form';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { useRef } from 'react';


const RowContainerDesktop = ({
    classes,
    selectedChildEditItem,
    item,
    index,
    editItem,
    editChildItem,
    selectedChildIndex,
    selectedChildItem,
    editedItemList,
    editedChildItemList,
    addSerialNumber,
    lotSerialValueEntered,
    onAccountOwnedSeleted,
    onIsSerialUnknown,
    deleteItem,
    displayPrice,
    showBundlefromTableList,
    bundleExpandCollapseIconClickHandler,
    isFromReportScreen,
    checkNewAddedProduct,
    vendorCaseErrorRedirection,

}) => {
     const childRef = useRef(null);
    return (
        <>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={2}
                borderRadius={6}
            >
                <ItemTemplateDesktop
                    key={item.cfn}
                    classes={classes}
                    item={item}
                    index={index}
                    edit={edit}
                    editItem={editItem}
                    editedItemList={editedItemList}
                    addSerialNumber={addSerialNumber}
                    lotSerialValueEntered={lotSerialValueEntered}
                    onAccountOwnedSeleted={onAccountOwnedSeleted}
                    deleteItem={deleteItem}
                    displayPrice={displayPrice}
                    showBundlefromTableList={showBundlefromTableList}
                    editChildItem={editChildItem}
                    selectedChildItem={selectedChildItem}
                    selectedChildEditItem={selectedChildEditItem}
                    selectedChildIndex={selectedChildIndex}
                    editedChildItemList={editedChildItemList}
                    bundleHeader={item.isBundleFromAddItem}
                    bundleExpandCollapseIconClickHandler={
                        bundleExpandCollapseIconClickHandler
                    }
                    onIsSerialUnknown={onIsSerialUnknown}
                    isFromReportScreen={isFromReportScreen}
                    checkNewAddedProduct={checkNewAddedProduct}
                    vendorCaseErrorRedirection={vendorCaseErrorRedirection}
                    childRef={childRef}
                />

                {item.isBundleExpanded &&
                    item.isBundleItem &&
                    item.children &&
                    item.children.length > 0 &&
                    item.children.map((subitem, i) => (
                        <Box
                            className={classes.paper}
                            my={1}
                            bgcolor={'#ffffff'}
                            boxShadow={2}
                            borderRadius={6}
                            style={{
                                display: 'block',
                                backgroundColor: '#FBFAFF',
                                boxShadow: '0px 0px 2px #00000029',
                                marginLeft: '20px',
                            }}
                            key={subitem + ' ' + i}
                        >
                            <ItemTemplateDesktop
                                key={subitem.cfn}
                                classes={classes}
                                item={subitem}
                                parentItem={item}
                                parentIndex={index}
                                index={i}
                                edit={edit}
                                editItem={(editProduct, childIndex) =>
                                    editItem(editProduct, childIndex, index)
                                }
                                editedItemList={(event, editItem, itemIndex) =>
                                    editedItemList(
                                        event,
                                        editItem,
                                        itemIndex,
                                        index
                                    )
                                }
                                addSerialNumber={(product, itemIndex) =>
                                    addSerialNumber(product, itemIndex, index)
                                }
                                lotSerialValueEntered={(
                                    event,
                                    item,
                                    itemIndex,
                                    lotItem,
                                    lotItemIndex
                                ) =>
                                    lotSerialValueEntered(
                                        event,
                                        item,
                                        itemIndex,
                                        lotItem,
                                        lotItemIndex,
                                        undefined,
                                        index
                                    )
                                }
                                onAccountOwnedSeleted={onAccountOwnedSeleted}
                                deleteItem={(id, itemIndex, lotindex) =>
                                    deleteItem(id, itemIndex, lotindex, index)
                                }
                                displayPrice={displayPrice}
                                isFromReportScreen={isFromReportScreen}
                                showBundlefromTableList={
                                    showBundlefromTableList
                                }
                                checkNewAddedProduct={checkNewAddedProduct}
                                editChildItem={editChildItem}
                                selectedChildItem={selectedChildItem}
                                selectedChildEditItem={selectedChildEditItem}
                                selectedChildIndex={selectedChildIndex}
                                editedChildItemList={editedChildItemList}
                                bundleHeader={false}
                                isChildItem
                            />
                        </Box>
                    ))}                
            </Box>
        </>
    );
};
export default RowContainerDesktop;

